import { useState } from "react"
import { Flex, Text, RadioButtons } from "components/common"
import styles from "./index.module.less"
import { t } from "i18next"
import EngagementTrendInsights from "./engagementTrendInsights"
import EngagementBreakdownInsights from "./engagementBreakdownInsights"

const EngagementInsightsPanel = ({ clientId }) => {
  const [selectedPanel, setSelectedPanel] = useState("trend")

  return (
    <Flex vertical gap="16px" className={styles.engagementPanel}>
      <Flex justify="space-between" align="center">
        <Text className="bold fs16">{selectedPanel === "trend" ? t("Engagement Insights") : t("Engagement Score")}</Text>

        <RadioButtons
          options={[
            { label: t("Trend"), value: "trend" },
            { label: t("Breakdown"), value: "breakdown" },
          ]}
          value={selectedPanel}
          onChange={event => setSelectedPanel(event?.target?.value)}
        />
      </Flex>

      {selectedPanel === "trend" ? <EngagementTrendInsights clientId={clientId} /> : null}
      {selectedPanel === "breakdown" ? <EngagementBreakdownInsights clientId={clientId} /> : null}
    </Flex>
  )
}

export default EngagementInsightsPanel
